/** Accent-insensitive search text: "pho" finds "Phở", "cha gio" finds "Chả giò" (FR-ORD-06). */
export const fold = (text: string) =>
  text.normalize('NFD').replace(/\p{M}/gu, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').toLowerCase();
